module.exports = __webpack_public_path__ + "media/images/icon-play-78073e1428ad6bdd026d6b4b268bc9fe.svg";